///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.dashboard = abcsetup.dashboard || {};
abcsetup.dashboard.abc_swiss = abcsetup.dashboard.abc_swiss || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.dashboard.abc_swiss = {
    /**
     * Yajra datatables have been init - this is the event
     */
    tableDrawCallback: function(table) {
        if (table == 'app_data_tables_r_f_q_swiss_events_data_table' || table == 'app_data_tables_r_f_q_swiss_events_data_tablearchive') {
            // Update events that are paused
            $('#' + table + ' tr').each(function () {
                if ($(this).find('td:eq(0)').find('.fa-exclamation-triangle').length) {
                    $(this).addClass('warning');
                }

                if ($(this).find('td:eq(0)').find('.fa-pen').length) {
                    $(this).addClass('pending');
                }

                if ($(this).find('td:eq(0)').find('.fa-pause').length) {
                    $(this).addClass('paused');
                }

                if ($(this).find('td:eq(0)').find('.fa-ban').length) {
                    $(this).addClass('deleted');
                }
            });
        }
    },
}
